<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">Listado de Anunciantes</h1>
    <div class="mb-6 flex justify-between items-center">
      <search-filter v-model="form.search" :show-filter="true" class="w-full max-w-md mr-4" @reset="reset">
      </search-filter>
      <inertia-link class="btn-indigo" :href="route('advertisers.create')">
        <span>Crear</span>
        <span class="hidden md:inline">Anunciante</span>
      </inertia-link>
    </div>
    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <tr class="text-left font-bold">
          <th class="px-6 pt-6 pb-4">Usuario</th>
          <th class="px-6 pt-6 pb-4">Nombre</th>
          <!-- <th class="px-6 pt-6 pb-4">Telefono</th> -->
          <th class="px-6 pt-6 pb-4">Email</th>
           <th class="px-6 pt-6 pb-4">Propiedades</th>
          <th class="px-6 pt-6 pb-4">Activo en Admin</th>

        </tr>

        <tr v-for="advertiser in advertisers.data" :key="advertiser.ID" :class="advertiser.properties.length == 0 ? 'bg-gray-100 hover:bg-blue-100 ' : ''" class="hover:bg-gray-100 focus-within:bg-gray-100">
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center text-blue-800" :href="route('advertisers.edit', advertiser.ID)">
               {{ advertiser.usuario }}
            </inertia-link>
            <!-- {{advertiser}} -->
          </td>
           <td class="border-t px-6">
            {{ advertiser.nombre }}
          </td>
           <!-- <td class="border-t px-6">
            {{ advertiser.fono }}
          </td> -->
           <td class="border-t px-6">
            {{ advertiser.correo }}  
          </td>
          <!-- <td class="border-t items-center">
            {{ advertiser.senia }} 
          </td> -->
          <td class="border-t items-center text-center px-6">
            {{  advertiser.properties.length }}
          </td>
           <td class="border-t text-center px-6">
           <span :class="advertiser.user ? 'bg-green-500' : 'bg-red-500'"  class="w-4 h-4  inline-block rounded-full"></span>
          </td>
            

         

          
        </tr>
        <tr v-if="advertisers.data.length === 0">
          <td class="border-t px-6 py-4" colspan="4">No se encontraron anunciantes.</td>
        </tr>
      </table>
    </div>
    <pagination class="mt-6" :links="advertisers.links" />
  </div>
</template>

<script>
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import Pagination from '@/Shared/Pagination'
import SearchFilter from '@/Shared/SearchFilter'

export default {
  metaInfo: { title: 'Anunciantes' },
  components: {
    Icon,
    Pagination,
    SearchFilter,
  },
  layout: Layout,
  props: {
    filters: Object,
    advertisers: Object,
  },
  data() {
    return {
      form: {
        search: this.filters.search,
        trashed: this.filters.trashed,
      },
    }
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function() {
        this.$inertia.get(this.route('advertisers'), pickBy(this.form), { preserveState: true })
      }, 150),
    },
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
  },
}
</script>
